define('rebrush/components/product/type/configurable/addtocartbutton',[
    'jquery',
    'lodash',
    'cartware/components/Registry',
    'cartware/components/_base',
    'cartware/jquery/bem',
    'bootstrap-popover',
    'bootstrap-button'
], function(
    $,
    _,
    Registry,
    Component,
    BEM
) {
    return Component.create({
        $init: function() {
            this.addToCartButtonBlock = BEM.block('product-detail-add-to-cart');
            this.popoverTemplate = _.template(this.addToCartButtonBlock.getElements('popover-template').html());
            Registry().retrieve('product.view.configurable.spConfig', _.bind(function(spConfig) {
                this.spConfig = spConfig;
                this.initializePopover();
                this.initializeEvents();
                this.updateButtonStatus();
            }, this));
        },

        initializeEvents: function() {
            var popoverShown = false;

            _.forEach(this.spConfig.settings, _.bind(function(select) {
                select.on('change', _.bind(this.updateButtonStatus, this));
            }, this));

            this.addToCartButtonBlock.on('mouseenter', _.bind(function() {
                if (!popoverShown && this.addToCartButtonBlock.bemHasModifier('disabled')) {
                    popoverShown = true;
                    this.addToCartButtonBlock.popover('show');
                }
            }, this));

            this.addToCartButtonBlock.on('mouseleave', _.bind(function() {
                this.addToCartButtonBlock.popover('hide');
                popoverShown = false;
            }, this));
        },

        initializePopover: function() {
            this.addToCartButtonBlock.popover({
                title: '',
                content: _.bind(function() {
                    var settings = this.spConfig.settings,
                        emptySetting = null;

                    if (!settings.length) {
                        return '';
                    }

                    $.each(settings, function() {
                        if (this.disabled || this.value === '') {
                            emptySetting = this;
                            return false;
                        }
                    });

                    if (!emptySetting) {
                        return '';
                    }

                    return this.popoverTemplate({ conf : $(emptySetting).data('label') });
                }, this),
                trigger: 'manual',
                placement: function() {
                    if ($(window).width() >= 768) {
                        return 'left';
                    }

                    return 'top';
                }
            });
        },

        updateButtonStatus: function() {
            if (this.isFullyConfigured()) {
                this.addToCartButtonBlock.bemRemoveModifier('disabled');
                this.addToCartButtonBlock.popover('hide');
            } else {
                this.addToCartButtonBlock.bemAddModifier('disabled');
            }
        },

        isFullyConfigured: function() {
            return !_.some(this.spConfig.state, function(value) { return value === false; });
        },

        destructor: function() {
            this.spConfig = null;
        }
    });
});
